module.exports = __webpack_public_path__ + "static/media/slide2.aefc7cd9.jpg";